import React from 'react';

export const Services_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PRODUCTION SERVICES</span>,
  },
];

export const Travel_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>TRAVEL & LIVING</span>,
  },
];

export const Locations_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>LOCATIONS</span>,
  },
];

export const Casting_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>CASTING</span>,
  },
];

export const Permits_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>PERMITTING</span>,
  },
];

export const Rent_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>EQUIPMENT RENTALS</span>,
  },
];

export const Crew_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>MULTILINGUAL CREW</span>,
  },
];

export const Insurance_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>INSURANCE</span>,
  },
];

export const All_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>NATIONWIDE COVERAGE (MEXICO)</span>,
  },
];
